<template>
  <div class="">
    <div class="bottom-banner flex flex-center">
      <div class="main-box flex flex-center">
        <!-- @click="jumpPage({ name: 'szStudio' })" -->
        <div class="item-box flex flex-center align-items-center">
          <login
            @loginSuccess="showLoginPop = false"
            :loginPath="'szStudio'"
            @close="close"
            ref="login"
          ></login>
        </div>
        <!-- <div
          class="item-box flex flex-center align-items-center"
          @click="jumpPage({ name: 'educationalBrand' })"
        >
          <div class="text2">名班主任<br/>工作室建设组</div>
        </div> -->
        <!-- <div
          class="item-box flex flex-center align-items-center"
          @click="
            jumpPage({
              name: 'szMicroClass',
            })
          "
        >
          <div class="text2">思政微课</div>
        </div> -->
      </div>
    </div>

    <div
      class="loginPop flex flex-center align-items-end"
      v-if="showLoginPop"
    >
      <login
        @loginSuccess="showLoginPop = false"
        :loginPath="loginPath"
        @close="close"
        ref="login"
      ></login>
    </div>
  </div>
</template>

<script>
import login from "../../components/login";
export default {
  name: "Index",
  components: {
    login,
  },
  data() {
    return {
      showLoginPop: false,
    };
  },
  watch: {
    showLoginPop(newNum) {
      if (newNum == true) {
        var _self = this;
        if (this.showLoginPop == true) {
          document.onkeydown = function () {
            var key = window.event.keyCode;
            if (key == 13) {
              _self.$refs.login.goLogin();
            }
          };
        }
      }
    },
  },
  methods: {
    jumpPage(path) {

      this.loginPath = path.name;
      if (this.$store.state.token === null) {
        this.showLoginPop = true;
      } else {
        this.$router.push({ name: path.name });
      }
    },
    close() {
      this.showLoginPop = false;
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
@import '@/assets/style/mixin.scss';

.img-box {
  width: 242px;
  height: 59px;
}
.bottom-banner {
  // height: 426px;
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 46px;
}
.main-box {
  padding: 10px;
}
.item-box {
  width: 675px;
  height: 420px;
  // height:424px;
  // margin-left: 56px;
  cursor: pointer;
  @include themeify{
    background:themed(home-item-bg);
    background-size: 100% 100%;
  }
}

.text2 {
  font-size: 48px;
  font-family: SourceHanSansSC;
  font-weight: 800;
  color: #000000;
  line-height: 79px;
  text-align: center;
}
.text2:hover {
  color: #00349f;
}
.loginPop {
  position: relative;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.52);
}
</style>
